import styles from "./Modal.module.scss";
import { MdClose } from "react-icons/md";
import { useFormik } from "formik";
import { toast } from "react-toastify";
import { useState, useEffect } from "react";

// firebase
import { db } from "../../../firebase";

export default function EditModal({ data, setOpen, reloadData }) {
  const [iconFile, setIconFile] = useState(null);
  const [iconPreview, setIconPreview] = useState(data?.icon || null);
  
  const close = () => {
    setOpen(false);
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      // Validate file type
      if (file.type !== 'image/svg+xml') {
        toast.error("Please select a valid SVG file", {
          theme: "colored",
        });
        return;
      }
      
      setIconFile(file);
      
      // Create preview
      const reader = new FileReader();
      reader.onload = (e) => {
        setIconPreview(e.target.result);
      };
      reader.readAsText(file);
    }
  };

  console.log(data, "data");
  const formik = useFormik({
    initialValues: {
      name: data?.name || "",
      value: data?.value || "",
      explanation: data?.explanation || "",
      icon: data?.icon || "",
    },
    validate: (values) => {
      const errors = {};
      if (!values.name) {
        errors.name = "Required";
      }
      if (!values.value) {
        errors.value = "Required";
      }
      return errors;
    },
    onSubmit: async (values, { resetForm }) => {
      try {
        let iconData = values.icon;
        
        // If there's a new uploaded file, read its content
        if (iconFile) {
          iconData = await new Promise((resolve) => {
            const reader = new FileReader();
            reader.onload = (e) => resolve(e.target.result);
            reader.readAsText(iconFile);
          });
        }
        
        await db.collection("roles-dropdown").doc(data.id).update({
          ...values,
          icon: iconData,
        });
        
        close();
        resetForm();
        setIconFile(null);
        toast.success("Role Item Updated Successfully", {
          theme: "colored",
        });
        reloadData();
      } catch (error) {
        toast.error("Error Updating Role Item", {
          theme: "colored",
        });
        console.error("Error updating document: ", error);
      }
    },
  });
  return (
    <div className={styles.modalContainer}>
      <div onClick={close} className={styles.clickAway}></div>
      <div className={styles.modal}>
        <button onClick={close}>
          <MdClose />
        </button>
        <form onSubmit={formik.handleSubmit} className="w-100">
          <div className={styles.content}>
            <h3>Role</h3>
            <span>
              This section is used to edit existing role option to the
              dropdown.
            </span>
            <hr />
            <div className={styles.inputs}>
              <span>Role</span>
              <input
                type="text"
                name="name"
                onChange={formik.handleChange}
                value={formik.values.name}
              />
              <span className={styles.error}>
                {formik.errors.name &&
                  formik.touched.name &&
                  formik.errors.name}
              </span>

              <span>Value</span>
              <input
                className={styles.abbInput}
                type="text"
                name="value"
                onChange={formik.handleChange}
                value={formik.values.value}
              />
              <span className={styles.error}>
                {formik.errors.value &&
                  formik.touched.value &&
                  formik.errors.value}
              </span>

              <span>Explanation</span>
              <textarea
                className={styles.explanationInput}
                name="explanation"
                onChange={formik.handleChange}
                value={formik.values.explanation || ""}
                placeholder="Enter role explanation..."
                rows="3"
              />

              <span>Icon (Optional)</span>
              <input
                type="file"
                accept=".svg"
                onChange={handleFileChange}
                style={{ marginBottom: '8px' }}
              />
              <small style={{ color: '#666', fontSize: '12px' }}>
                Upload an SVG file. The icon will be displayed at 50x50px.
              </small>
              {iconPreview && (
                <div style={{ marginTop: '8px', padding: '8px', border: '1px solid #ddd', borderRadius: '4px', backgroundColor: '#f9f9f9' }}>
                  <small style={{ color: '#666', display: 'block', marginBottom: '4px' }}>Preview (50x50px):</small>
                  <div 
                    style={{ 
                      display: 'inline-block',
                      width: '60px',
                      height: '60px',
                      overflow: 'hidden',
                      border: '1px solid #ccc',
                      borderRadius: '2px',
                      padding: '5px',
                      backgroundColor: 'white'
                    }}
                    dangerouslySetInnerHTML={{ 
                      __html: iconPreview.replace(
                        /<svg([^>]*)>/g,
                        '<svg$1 width="50" height="50" viewBox="0 0 50 50" style="display: block; width: 100%; height: 100%; margin: 0; padding: 0;">'
                      )
                    }}
                  />
                  {iconFile && (
                    <div style={{ marginTop: '4px', fontSize: '11px', color: '#666' }}>
                      File: {iconFile?.name}
                    </div>
                  )}
                  {!iconFile && data?.icon && (
                    <div style={{ marginTop: '4px', fontSize: '11px', color: '#666' }}>
                      Current icon
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>
          <div className={styles.btns}>
            <button onClick={close}>Cancel</button>
            <button type="submit">Save</button>
          </div>
        </form>
      </div>
    </div>
  );
}
